"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZodType = exports.outputSchema = exports.inputSchema = exports.ZodTypes = void 0;
var parser_1 = require("../parser");
var index_1 = require("../index");
var ZodTypes;
(function (ZodTypes) {
    ZodTypes["string"] = "string";
    ZodTypes["number"] = "number";
    ZodTypes["bigint"] = "bigint";
    ZodTypes["boolean"] = "boolean";
    ZodTypes["date"] = "date";
    ZodTypes["undefined"] = "undefined";
    ZodTypes["null"] = "null";
    ZodTypes["array"] = "array";
    ZodTypes["object"] = "object";
    ZodTypes["union"] = "union";
    ZodTypes["intersection"] = "intersection";
    ZodTypes["tuple"] = "tuple";
    ZodTypes["record"] = "record";
    ZodTypes["map"] = "map";
    ZodTypes["function"] = "function";
    ZodTypes["lazy"] = "lazy";
    ZodTypes["literal"] = "literal";
    ZodTypes["enum"] = "enum";
    ZodTypes["nativeEnum"] = "nativeEnum";
    ZodTypes["promise"] = "promise";
    ZodTypes["any"] = "any";
    ZodTypes["unknown"] = "unknown";
    ZodTypes["never"] = "never";
    ZodTypes["void"] = "void";
    ZodTypes["transformer"] = "transformer";
    ZodTypes["optional"] = "optional";
    ZodTypes["nullable"] = "nullable";
})(ZodTypes = exports.ZodTypes || (exports.ZodTypes = {}));
exports.inputSchema = function (schema) {
    if (schema instanceof index_1.ZodTransformer) {
        return exports.inputSchema(schema._def.input);
    }
    else {
        return schema;
    }
};
exports.outputSchema = function (schema) {
    if (schema instanceof index_1.ZodTransformer) {
        return exports.inputSchema(schema._def.output);
    }
    else {
        return schema;
    }
};
var ZodType = (function () {
    function ZodType(def) {
        var _this = this;
        this.safeParse = function (data, params) {
            try {
                var parsed = _this.parse(data, params);
                return { success: true, data: parsed };
            }
            catch (err) {
                if (err instanceof index_1.ZodError) {
                    return { success: false, error: err };
                }
                throw err;
            }
        };
        this.parseAsync = function (value, params) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.parse(value, __assign(__assign({}, params), { async: true }))];
                    case 1: return [2, _a.sent()];
                }
            });
        }); };
        this.safeParseAsync = function (data, params) { return __awaiter(_this, void 0, void 0, function () {
            var parsed, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, this.parseAsync(data, params)];
                    case 1:
                        parsed = _a.sent();
                        return [2, { success: true, data: parsed }];
                    case 2:
                        err_1 = _a.sent();
                        if (err_1 instanceof index_1.ZodError) {
                            return [2, { success: false, error: err_1 }];
                        }
                        throw err_1;
                    case 3: return [2];
                }
            });
        }); };
        this.spa = this.safeParseAsync;
        this.refine = function (check, message) {
            if (message === void 0) { message = 'Invalid value.'; }
            if (typeof message === 'string') {
                return _this._refinement(function (val, ctx) {
                    var result = check(val);
                    var setError = function () {
                        return ctx.addIssue({
                            code: index_1.ZodIssueCode.custom,
                            message: message,
                        });
                    };
                    if (result instanceof Promise) {
                        return result.then(function (data) {
                            if (!data)
                                setError();
                        });
                    }
                    if (!result) {
                        setError();
                        return result;
                    }
                });
            }
            if (typeof message === 'function') {
                return _this._refinement(function (val, ctx) {
                    var result = check(val);
                    var setError = function () {
                        return ctx.addIssue(__assign({ code: index_1.ZodIssueCode.custom }, message(val)));
                    };
                    if (result instanceof Promise) {
                        return result.then(function (data) {
                            if (!data)
                                setError();
                        });
                    }
                    if (!result) {
                        setError();
                        return result;
                    }
                });
            }
            return _this._refinement(function (val, ctx) {
                var result = check(val);
                var setError = function () {
                    return ctx.addIssue(__assign({ code: index_1.ZodIssueCode.custom }, message));
                };
                if (result instanceof Promise) {
                    return result.then(function (data) {
                        if (!data)
                            setError();
                    });
                }
                if (!result) {
                    setError();
                    return result;
                }
            });
        };
        this.refinement = function (check, refinementData) {
            return _this._refinement(function (val, ctx) {
                if (!check(val)) {
                    ctx.addIssue(typeof refinementData === 'function'
                        ? refinementData(val, ctx)
                        : refinementData);
                }
            });
        };
        this._refinement = function (refinement) {
            return new _this.constructor(__assign(__assign({}, _this._def), { checks: __spread((_this._def.checks || []), [{ check: refinement }]) }));
        };
        this.optional = function () { return index_1.ZodOptional.create(_this); };
        this.or = this.optional;
        this.nullable = function () {
            return index_1.ZodNullable.create(_this);
        };
        this.array = function () { return index_1.ZodArray.create(_this); };
        this.isOptional = function () { return _this.safeParse(undefined).success; };
        this.isNullable = function () { return _this.safeParse(null).success; };
        this._def = def;
        this.parse = parser_1.ZodParser(this);
    }
    ZodType.prototype.is = function (u) {
        try {
            this.parse(u);
            return true;
        }
        catch (err) {
            return false;
        }
    };
    ZodType.prototype.check = function (u) {
        try {
            this.parse(u);
            return true;
        }
        catch (err) {
            return false;
        }
    };
    ZodType.prototype.transform = function (input, transformer) {
        if (transformer) {
            return index_1.ZodTransformer.create(this, input, transformer);
        }
        return index_1.ZodTransformer.create(this, exports.outputSchema(this), input);
    };
    ZodType.prototype.default = function (def) {
        var _this = this;
        return index_1.ZodTransformer.create(this.optional(), this, function (x) {
            return x === undefined
                ? typeof def === 'function'
                    ? def(_this)
                    : def
                : x;
        });
    };
    return ZodType;
}());
exports.ZodType = ZodType;
//# sourceMappingURL=base.js.map